import React, { useState, useEffect, useRef, useContext } from 'react';
import Chart from 'chart.js';
import {Button,Typography,Box} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { UserContext } from '../../../context/UserContext'
import ErrorMessage from "../../../common/ErrorMessage/ErrorMessage"
import BarchartModuleEditDialog from './BarchartModal_Edit_Dialog';
import { BASE_URL } from "../../../baseUrl"

const BarChartModalEdit = ({open, handleClose,id_client, id_strategy, desc_strategy,type_request, size}) => {

    /*General variables*/
    const [login] = useContext(UserContext);
    const [errorMessage, setErrorMessage] = useState("");
    const [strategydata, setStrategyData] = useState([]);

    /*variable to draw the barchart*/
    const chartRef = useRef(null); // Add a ref for the chart canvas
    const years_ = [];
    const listBars = [];

    /*variables to edit or insert*/
    const [isStrategySelected, setIsStrategySelected] = useState(false); // New state variable
    const [selectedBarData, setSelectedBarData] = useState({ year: null, value: null, idEntry:null, month:null, TS:null }); 
    const [openedit, setOpenEdit] = useState("")
    const [type_action, setTypeAction] = useState("")
    const [maxyear, setMaxYear] = useState("")
    const [refreshneeded, setRefreshNeeded] = useState(false)

    /*Load strategy data*/
    const getStrategydata = async () => {
        const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
        },
        };
        console.log('entry value of client and strategy id')
        console.log(id_client)
        console.log(id_strategy)
        const response = await fetch(BASE_URL + `/api/bargraph/${id_client}/${id_strategy}`, requestOptions);
        if (!response.ok) {
            setErrorMessage("Something went wrong. Couldn't load the bargraph data");
        } else {
            const data = await response.json();
            console.log("*****************************")
            console.log("***strategy data to load*****")
            console.log(data)

            //Calculate the max Year:
            setMaxYear(Math.max(...data.map(item => item.Year)));

            //Set the whole array:
            setStrategyData(data);         
        }
    };

    /*Insert a new entry*/
    const handleReportStrategyData= async (strategyData) => {

        try{
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + login.token,
                },
                body: JSON.stringify({
                    Year: parseInt(strategyData['year']),
                    Month: parseInt(strategyData['month']),
                    Value: parseFloat(strategyData['value']),
                    Category: "",
                    TS: strategyData['TS'],
                    X_Axis_e: 0,
                    Y_Axis_e: 0
                }),
            };
           
  
            const response = await fetch(BASE_URL + `/api/bargraph/${id_client}/${id_strategy}/${strategyData['year']}`, requestOptions);

        
            if (!response.ok) {
                setErrorMessage("Something went wrong. Couldn't load the bargraph data");
            } else {
                //refresh after confirm the insert - reload
                setRefreshNeeded(true)
            } 
             
          } catch (error){
            setErrorMessage("Something went wrong when creating a data strategy");
        }
    }
    
    /*Function to update an existing value*/
    const handleUpdateStrategyData= async (strategyData) => {
        
        try{
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + login.token,
                },
                body: JSON.stringify({
                    Year: parseInt(strategyData['year']),
                    Month: parseInt(strategyData['month']),
                    Value: parseFloat(strategyData['value']),
                    Category: "",
                    TS: strategyData['TS'],
                    X_Axis_e: 0,
                    Y_Axis_e: 0
                }),
            };
            
            const response = await fetch(BASE_URL + `/api/bargraph/${id_client}/${id_strategy}/${strategyData['year']}/${strategyData['idEntry']}`, requestOptions);
            if (!response.ok) {
                setErrorMessage("Something went wrong. Couldn't update the bargraph data");
            } else {
                //refresh after confirm the insert - reload
                setRefreshNeeded(true)
            } 
             
          } catch (error){
            setErrorMessage("Something went wrong when updating a data strategy");
        }
            
    };

    /*Report progress: Update - click from coming from the barchart*/
    const handleBarClick = (year, value, idEntry) => {
        let create_month = 0
        let create_TS = ''
        setSelectedBarData({ year:year, value:value, idEntry:idEntry, month:create_month, TS:create_TS }); // Set the selected year and value for the clicked bar
        setTypeAction(0)
        setOpenEdit(true)  
    };
    

    const handleDataEntrySubmit = () => {
        if (type_action === 1){
            console.log("REQUEST TO NSERT")
            console.log(selectedBarData)
            handleReportStrategyData(selectedBarData)
        } else if (type_action === 0) {
            console.log("REQUEST TO UPDATE")
            console.log(selectedBarData)
            handleUpdateStrategyData(selectedBarData)
        }
    }

    const handleCreateDataEntry = () => {
        //static values not necessary to create because they will be set fromt the dialog. 
        // however they need to be initialized
        let create_value = 0
        let create_idEntry = 0
        let create_month = 0
        let create_TS = ''
        setSelectedBarData({ year:maxyear+1, value:create_value, idEntry:create_idEntry, month:create_month, TS:create_TS})
        setTypeAction(1)
        setOpenEdit(true)
    }

    /*Code to draw the bargraph*/
    const drawbarchart = async() => {
        console.log(strategydata)
        let validfromdate = strategydata[0].ValidFrom
        console.log(validfromdate)
        let validfrom = parseInt(validfromdate.split("-")[0])
        let validtodate = strategydata[0].ValidTo
        let validto = parseInt(validtodate.split("-")[0])
        console.log(validfrom)

        for (let i = validfrom; i <= validto; i++) {
            years_.push(i);
          }

        let linedata = Array(years_.length).fill(null)
        let linedataIDentry = Array(years_.length).fill(null)
        let barcolors = Array(years_.length).fill("rgba(54, 162, 235, 0.2)")


        
        //setYearList(years_.slice(years_.findIndex((index) => index >= validfrom)))
        let yearlist = years_.slice(years_.findIndex((index) => index >= validfrom))
        console.log("list of years")
        console.log(yearlist)

        // Calculate the new lineData from the fetched strategies
        linedata = years_.map(year => {
            const strategyForYear = strategydata.find(strategy => strategy.Year === year);
            return strategyForYear ? strategyForYear.Value : null;
        });

        //Calculate the new lineData "ID ENTRY" from strategies
        linedataIDentry = years_.map(year => {
            const strategyForYear_IDEntry = strategydata.find(strategy => strategy.Year === year);
            return strategyForYear_IDEntry ? strategyForYear_IDEntry.ID_DataEntry : null;
        });
        
        //return 2050 - Cyear;
        const YrstoEnd = () => {
            return validto-validfrom
        };
    
        const DivFactorBars = () => {
            return 1 / YrstoEnd();
        };
    
        const CYIndexLoc = () => {
            return years_.findIndex((index) => index >= validfrom);
        
        };
        
        let i = 0;
            while (i <= validto - validfrom) {
                const value = (i * DivFactorBars() * 100).toFixed(2);
                listBars.push(parseFloat(value));
                i++;
            }
        
        let chart;
        
        if (type_request === 0){
            if (chartRef.current) {
                const ctx = chartRef.current.getContext("2d"); // Use the ref to get the chart canvas
            
                chart = new Chart(ctx, {
                type: "bar",
                data: {
                        labels: yearlist,
                        datasets: [
                        {
                            type: "bar",
                            label: "Expected Progress",
                            data: listBars,
                            backgroundColor: barcolors.slice(CYIndexLoc(validfrom)),
                            borderColor: "rgba(54, 162, 235, 1)",
                            borderWidth: 1,
                        },
                        {
                            fill: true,
                            type: "line",
                            label: "Progress Reported",
                            data: linedata,
                            borderColor: "rgba(255, 239, 109, 0.5)",
                        },
                        ],
                    },
                    
                });
                
                    chartRef.current.chart = chart; //Store the chart instance in the ref
                
            } else {
                window.scrollTo(0, 0);
            }
        } else {
            if (chartRef.current) {
                const ctx = chartRef.current.getContext("2d"); // Use the ref to get the chart canvas
            
                chart = new Chart(ctx, {
                type: "bar",
                data: {
                        labels: yearlist,
                        datasets: [
                        {
                            type: "bar",
                            label: "Expected Progress",
                            data: listBars,
                            backgroundColor: barcolors.slice(CYIndexLoc(validfrom)),
                            borderColor: "rgba(54, 162, 235, 1)",
                            borderWidth: 1,
                        },
                        {
                            fill: true,
                            type: "line",
                            label: "Progress Reported",
                            data: linedata,
                            borderColor: "rgba(255, 239, 109, 0.5)",
                        },
                        ],
                    },
                                        
                    options: {
                        onClick: function(evt, activeElements) {
                        if (activeElements.length === 0) return;
                        const firstPoint = this.getElementAtEvent(evt)[0];
                        if (firstPoint) {
                            const index = firstPoint._index;
                            const idEntry = linedataIDentry[CYIndexLoc(validfrom) + index]
            
                            if (idEntry !== null) {
                            const value = linedata[CYIndexLoc(validfrom) + index];
                            const year = years_[CYIndexLoc(validfrom) + index];
                            handleBarClick(year, value, idEntry);
                            }
                        }
                        }
                    }
                    
                });
                
                    chartRef.current.chart = chart; //Store the chart instance in the ref
                
            } else {
                window.scrollTo(0, 0);
            }
        }
    }
    
    /*Effect instruction when dialog is open and when strategy data is loaded*/
    useEffect(() => {
        if (open) {
            getStrategydata();
        }
      }, [open, id_client, id_strategy]);

    useEffect(() => {
        if (strategydata.length>0) {
            console.log('time to draw!')
            console.log(strategydata.length)
            drawbarchart();
        }
    }, [strategydata]);

    useEffect(()=>{
        if (refreshneeded) {
            const fetchData = async () => {
                await getStrategydata();
                setRefreshNeeded(false); // Reset the updateNeeded flag after the data is fetched
            };

            fetchData();
        }
    }, [refreshneeded]);

    return(
       <Dialog
            maxWidth={size} fullWidth
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    handleClose();
                }
            }}
            ModalProps={{disableEnforceFocus: true}}
            classes={{ paper: 'custom-dialog' }}
            PaperProps={{ style: { backgroundColor: '#231E39'}}}
        >
            {type_request === 0 ?(
                <>    
                    <DialogTitle style={{color: 'white'}}>Currently viewing: - {desc_strategy}</DialogTitle>
                    <DialogContent>   
                        { (strategydata.length>0)? (
                            <canvas ref={chartRef} id="myChart" width="1800" height="900"></canvas>
                        ) : (
                            <p>This strategy hasn't registered any progress yet!</p>
                        )}
                
                    </DialogContent>

                    <DialogActions
                        sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}
                    >
                        <Button 
                            onClick={handleClose}
                            sx={{
                                paddingRight: '1.5rem',
                                marginRight: '1.5rem',
                                border: '1px solid var(--main-color)',
                        
                        }}>Cancel</Button>
                        
                    </DialogActions>
                </>
            ):(
                <>
                    <DialogTitle style={{color: 'white'}}>Currently Reporting Progress for: {desc_strategy}</DialogTitle>
                    
                    <DialogContent>   
                        { (strategydata.length>0)? (
                            <canvas ref={chartRef} id="myChart" width="1200" height="500"></canvas>
                        ) : (
                            <p>This strategy hasn't registered any progress yet!</p>
                        )}

                    <BarchartModuleEditDialog open={openedit} onClose={() => setOpenEdit(false)} onSubmit={handleDataEntrySubmit} type_action= {type_action} data_selected = {selectedBarData}/>
                
                    </DialogContent>

                    <DialogActions
                        sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}
                    >
                        <Button 
                            onClick={handleCreateDataEntry}
                            sx={{
                                paddingRight: '1.5rem',
                                marginRight: '1.5rem',
                                border: '1px solid var(--main-color)',
                        
                        }}>Create a new data Entry</Button>

                        <Button 
                            onClick={handleClose}
                            sx={{
                                paddingRight: '1.5rem',
                                marginRight: '1.5rem',
                                border: '1px solid var(--main-color)',
                        
                        }}>Done</Button>
                        
                    </DialogActions>
                </>
            )}
       </Dialog> 
    )
}

export default BarChartModalEdit